import { NielsenRenderType, NielsenDCRMetaData } from './nielsen-meta'
/**
 * Expected output for the following Dcr metadata is
 *
 * for PerthNow/TheWest: (SWM-5165, SWM-5061)
 *  section: 'home' for / or first level topic (e.g 'news' if /news)
 *  segA: undefined
 *  segB: 'The West Australian - website' or 'PerthNow - website'
 *
 */
export function getWANDcrMeta(
    siteName: string,
    pathName: string,
    renderType: NielsenRenderType
): NielsenDCRMetaData {
    // const siteName = getNielsenSiteName(product)
    // generate correct segC based on renderType
    let segC = undefined
    switch (renderType) {
        case 'google-amp':
            segC = `${siteName} - Google AMP`
            break
        case 'web':
        default:
            break
    }
    // dcr meta for perthnow / the west, segA not used
    return {
        section: `${siteName} - website`,
        segB: getWANTopLevelSection({ pathname: pathName }),
        segC,
    }
}

export function getWANTopLevelSection(location: { pathname: string }) {
    const path = location.pathname
    // Should not occur but if it does return unknown section
    if (path.indexOf('/') === -1) {
        return 'unknown'
    }

    const base = 'home'

    const item = path.split('/')[1]
    const resolved = item

    return path === '/' ? base : resolved
}
